// Static fallback products data - used when API call fails (ad blockers, network issues)
// Update this when Stripe products change

const STATIC_PRODUCTS = [
  {
    productId: 'prod_TulRdEMP5vcK5J',
    name: 'Starter',
    role: 'basic',
    active: true,
    metadata: { firebaseRole: 'basic', queries: '20' },
    up_to: '20',
    icon: 'Starter',
    prices: {
      priceId: 'price_1SwvukKXknTB7oMVfU8jlwSk',
      priceData: { unit_amount: 999 }
    }
  },
  {
    productId: 'prod_TulRQm4iYBfWEr',
    name: 'Pro',
    role: 'pro',
    active: true,
    metadata: { firebaseRole: 'pro', queries: '40' },
    up_to: '40',
    icon: 'Pro',
    prices: {
      priceId: 'price_1SwvuvKXknTB7oMVDnu9gT9q',
      priceData: { unit_amount: 1999 }
    }
  },
  {
    productId: 'prod_TulRpXtyHUVgaC',
    name: 'Unlimited',
    role: 'unlimited',
    active: true,
    metadata: { firebaseRole: 'unlimited', queries: '-1' },
    up_to: '-1',
    icon: 'Unlimited',
    prices: {
      priceId: 'price_1Swvv5KXknTB7oMV7hYZvkHI',
      priceData: { unit_amount: 4999 }
    }
  }
];

export default STATIC_PRODUCTS;
